module.exports = __webpack_public_path__ + "img/ps.b82bed4e.svg";